import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import Policies from "./pages/Policies";
import PreOrderPage from "./pages/PreOrderPage";
import CustomizePage from "./pages/CustomizePage";
import CheckoutPage from "./pages/CheckoutPage";
import PaymentSuccess from "./pages/PaymentSuccess";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/policies" element={<Policies />} />
        <Route path="/preorder/:productId" element={<PreOrderPage />} />
        <Route path="/customize/:productId" element={<CustomizePage />} />
        <Route path="/checkout/:productId" element={<CheckoutPage />} />
        <Route path="/buy/:productId" element={<PreOrderPage />} />
        <Route path="/success" element={<PaymentSuccess />} />
      </Routes>
    </Router>
  );
}

export default App;
